import { lazy, Suspense } from 'react';
import LeafletMap from './LeafletMap';
import type { MapViewProps } from './types';

const GoogleMap = lazy(() => import('./GoogleMap'));

export default function MapView({ kind, ...props }: MapViewProps & { kind: 'leaflet' | 'google' }) {
  if (kind === 'google') {
    return (
      <Suspense fallback={<div className={`map-view map-view--loading ${props.className ?? ''}`} />}>
        <GoogleMap {...props} />
      </Suspense>
    );
  }
  return <LeafletMap {...props} />;
}
